<!-- 热门话题 -->
<template>
    <div class="hot-subject">
        <div class="title cont-row">
            <div class="flex-cont"><img src="https://media6.imgyb.xyz/media/v1/image/8034f5c01ee5484dd8bd92cfc5785f6c.png" alt=""></div>
            <a href="https://forum.yorkbbs.ca/detail/80ad081d-b6ac-46d6-bf1a-d063f8982a57?topic=chat" target="_blank"><span>活动规则</span><i class="yk yk-arrow-right"></i></a>
        </div>
        <ul class="subject-list">
            <li class="cont-row" v-for="(item,index) in list" :key="index">
                <img src="https://media2.imgyb.xyz/media/v1/image/7e2ddd2dc389e7f7c664723dd5a10014.png" alt="">
                <div class="flex-cont">
                    <div class="main-title">
                        
                       
                            
                    
                        <a :href="'/publish/dining?subject=88ebeacf-27cf-48d7-8fc1-51ebf15b0bde'|hostBuild('forum')" target="_blank"> <span class="title-txt">{{item.subject}}</span><i class="yk yk-cms_edit"></i> </a>
                    </div>
                    <div class="desc">{{item.desc}}</div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name:'HotSubject',
    data(){
        return {
            list:[
                {
                    subject:'#我的拿手菜#',
                    desc:'分享厨艺，增加生活的蜜意~',
                    href:'#'
                },
                {
                    subject:'#多伦多美食探店 #',
                    desc:'品味好滋味，做探店品鉴官~',
                    href:'#'
                },
                {
                    subject:'#晒我家娃的学生午餐#',
                    desc:'装的是爸爸妈妈满满爱意啊~',
                    href:'#'
                },
                {
                    subject:'#安利好吃零食 #',
                    desc:'分享的是美味，种草的是好心情~',
                    href:'#'
                },
                {
                    subject:'#方便面大比拼#',
                    desc:'解锁方便面的100种吃法',
                    href:'#'
                },
                {
                    subject:'#茶饮店的“真”NO.1 #',
                    desc:'你喜欢的，才是最好喝的那一杯~',
                    href:'#'
                },
            ]
        }
    }
}
</script>
<style lang="less" scoped>
.hot-subject{
    background: url(https://media3.imgyb.xyz/media/v1/image/4f62d6cefb34536d17d9a378311fed8d.png) repeat 15px 15px #fff; border:2px solid #000000; border-radius: 20px; padding: 30px 30px 5px; overflow: hidden; margin-bottom: 30px;
    > .title{
        margin-bottom: 25px;
        a{
            color: #e43a3a; 
            &:hover{text-decoration: underline;}
            /* span{color: #FF4526;}
            i{color: #e43a3a;} */
        }
    }    
    .subject-list{
        display: flex; flex-wrap: wrap;
        li{
            align-items: flex-start; width: 50%; margin-bottom: 25px;
            > img{margin-top: 5px;}
            .flex-cont{
                margin-left: 10px;
                .main-title{
                    font-size: 18px; line-height: 30px;margin-bottom:5px;
                    .title-txt{color: #FF4526; font-weight: bold; margin-right: 10px;
                        &:hover{
                           opacity: 0.8;
                        }
                    }
                    
                }
                .desc{font-size: 16px; line-height: 22px; color: #4A4A4A;}
            }
        }
    }
}
@media screen and (max-width:768px){
    .hot-subject{
        border-radius: 10px;
        .subject-list{
            li{width: 100%;}
        }
    }
}
</style>